import React from 'react';
import moment from 'moment-timezone';
import LoadingSpinner from '../spinner/LoadingSpinner';
import WithOnlyOnDesktop from '../onlyOnDesktop/withOnlyOnDesktop';
import ProfessionalsSubtype from './ProfessionalsSubtype';
import SSNField from './SSNField';
import { mapCaregiversCertifications, getProfessionalCityState } from '../../utils/ProfessionalsUtils';
import { PencilIcon, InfoIcon } from '../icons';

const ProfessionalEmployeeDetails = ({ isFetching, professional, onEdit, isFlex, EmployeeIdsSection }) => {
	const professionalCertifications = mapCaregiversCertifications(professional);

	if (isFetching) {
		return (
			<div className="spinner-center-wrapper" key="spinner">
				<LoadingSpinner className="saving-spinner" />
			</div>
		);
	}

	if (!professional && !isFetching) {
		return null;
	}

	return (
		<WithOnlyOnDesktop>
			<div className="employee-details__wrapper">
				<div className="name-and-licenses__wrapper">
					<div className="d-flex justify-content-between professional-info-header">
						<h2>Professional Information</h2>
						{!isFlex && professional.roles_no <= 1 && (
							<button type="button" className="edit-button" onClick={onEdit}>
								<PencilIcon color="#7200A0" width={12} height={12} />
								Edit
							</button>
						)}
					</div>
					<div className="professional-info-section">
						<div className="details__wrapper">
							<div className="details">
								<h3>Name</h3>
								<h4>
									{professional.first_name || '-'} {professional.last_name || '-'}
								</h4>
							</div>
							{!isFlex && professional.roles_no === 1 && (
								<>
									<div className="details">
										<SSNField label="SSN" value={professional.ssn} />
									</div>
									<div className="details">
										<h3>Date of Birth</h3>
										<h4>{professional.birth_date ? moment(professional.birth_date).format('MM/DD/YYYY') : '-'}</h4>
									</div>
								</>
							)}
						</div>
						<div className="home-details__wrapper">
							{professionalCertifications.map((certif) => (
								<div className="home-details-license__wrapper" key={certif.resource_type_id || 'no-cert'}>
									<div className="home-details license-type">
										<h3>License Type</h3>
										<h4>{certif.resource_type}</h4>
									</div>
									<ProfessionalsSubtype subtypeTitle="State" subtypes={certif.states} type="code" />
									<ProfessionalsSubtype subtypeTitle="Specialties" subtypes={certif.specialties} type="label" />
								</div>
							))}
							{!isFlex && (
								<div className="credentials-info-banner">
									<InfoIcon />
									<span>You can edit this anytime on the Credentials tab</span>
								</div>
							)}
						</div>
					</div>

					{isFlex && <EmployeeIdsSection />}

					<div className="home-details__wrapper professional-info-section">
						<div className="home-details">
							<h3>Street address</h3>
							<h4>{professional.address || '-'}</h4>
						</div>
						<div className="home-details">
							<h3>City, State</h3>
							{getProfessionalCityState(professional)}
						</div>
						<div className="home-details">
							<h3>ZIP</h3>
							<h4>{professional.zip_code || '-'}</h4>
						</div>
					</div>

					{!isFlex && (
						<div className="details__wrapper details">
							<h3>Preferred contact method</h3>
							<h4>{professional.preferred_contact_method_name || '-'}</h4>
						</div>
					)}
					<div className="details__wrapper details">
						<h3>Cell phone</h3>
						<h4>{professional.phone_number || '-'}</h4>
					</div>
					<div className="details-email__wrapper">
						<h3>Email</h3>
						<h4>{professional.email || '-'}</h4>
					</div>
				</div>
			</div>
		</WithOnlyOnDesktop>
	);
};

export default ProfessionalEmployeeDetails;
